import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "../customerComm.styles";
import locationIcon from "../../assets/icons/map-pin.svg";
import {
  fetchOrdersFilterChipsDisplayCount,
  fetchPlanningOrderListByFilterHistory,
  exportToExcel,
  resetExportInitiated,
} from "../redux/customerCommSlice";
import {
  historyOrdersDataTransform,
  createFilterPayload,
} from "../../mocks/customerCommunications/response.transforms";
import { getOrderStatusField } from "../../mocks/express/response.transforms";
import { getConsignmentStatusField } from "../../mocks/routePlanning/response.transforms";
import HistoryBase from "./HistoryBase";

const useSelectorData = () => {
  const dispatch = useDispatch();
  const data = useSelector((state: any) => state.customerCommunication);
  return { ...data, dispatch };
};
const useCommonSelector = () => useSelector((state: any) => state.common);

const HistoryStandard = () => (
  <HistoryBase
    useSelectorData={useSelectorData}
    useCommonSelector={useCommonSelector}
    useStyles={useStyles}
    locationIcon={locationIcon}
    historyOrdersDataTransform={historyOrdersDataTransform}
    createFilterPayload={createFilterPayload}
    fetchOrderListByFilterHistory={fetchPlanningOrderListByFilterHistory}
    exportToExcelActionCreator={exportToExcel}
    fetchOrdersFilterChipsDisplayCount={fetchOrdersFilterChipsDisplayCount}
    resetExportInitiated={resetExportInitiated}
    getOrderStatusField={getOrderStatusField}
    getConsignmentStatusField={getConsignmentStatusField}
  />
);

export default HistoryStandard;